import type { IRegistrationStep } from '../hooks/types';
import { addedUserByTypeEnum } from '../hooks/types';
import useRegisterMethods from '../hooks/useRegisterMethods';
import { useOnBoardingDrawer } from '../OnBoardingDrawerProvider';
import InviteSmsStep from './InviteSmsStep';
import PatientDetailesStep from './PatientDetailesStep';
import RegistrationStep from './RegistrationStep';

export default function useNewPatientStep() {
  const {
    contextData: { addedUserByType, patient },
  } = useOnBoardingDrawer();
  const registerMethods = useRegisterMethods();

  return [
    {
      label: 'Registration',
      Component: RegistrationStep,
      isAllow: registerMethods.length !== 1,
      isBackHidden: !addedUserByType || addedUserByType === addedUserByTypeEnum.manually,
    },
    {
      label: 'Patient Details',
      Component: PatientDetailesStep,
      isAllow: true,
      isBackHidden: !!patient?.uuid || registerMethods.length === 1,
      isCancelHidden: true,
    },
    {
      label: 'Complete & Invite',
      Component: InviteSmsStep,
      className: 'overflow-y-hidden',
      btnClassName: 'w-1/2',
      isAllow: true,
      isBackHidden: true,
      isCancelHidden: true,
    },
  ].filter((step) => step?.isAllow) as IRegistrationStep[];
}
